export default __webpack_public_path__ + "static/media/close.8029efe9.svg";